import { connect } from 'react-redux';

import eventsActionCreators from '_store/_actions/events';

import EventForm from './EventForm';

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  onCreateEvent: eventsActionCreators.createEvent,
  onUpdateEvent: eventsActionCreators.updateEvent,
  onDeleteEvent: eventsActionCreators.deleteEvent,
  onFetchEvent: eventsActionCreators.fetchEvent,
};

export default connect(mapStateToProps, mapDispatchToProps)(EventForm);
